import script from "./SlotModalRolesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlotModalRolesList.vue?vue&type=script&setup=true&lang=ts"

import "./SlotModalRolesList.vue?vue&type=style&index=0&id=1fe8ee60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fe8ee60"]])

export default __exports__